module.exports = __webpack_public_path__ + "img/card-random.ae703437.svg";